import React from 'react';
import styles from './Section.module.scss';
import cn from 'classnames';

const Section = (props) => (
  <section className={cn(styles.section, props.className)}>{props.children}</section>
);

export default Section;
